ACC.checkoutPreValid = {

    _autoload: [

        ['init', $('.creditcard-paypal-wrapper,.creditcard-nz-wrapper').length !== 0],
    ],

    state: {
        newCard: {
            cardNumber: false,
            expireMonth: false,
            expireYear: false,
            cvv: false,
        },
        savedCard: {
            cvv: false,
        },
        zipPayTerms: false,
        terms: false,
        hasCalculatedTaxes: true,
    },

    method: {
        newCart: false,
    },

    init() {
        ACC.checkoutPreValid.checkRadioBtn();
        ACC.checkoutPreValid.addRadioHandler();
    },

    checkRadioBtn() {
        $.each($('.c-radiobtn__input'), (index, input) => {
            if ($(input).is(':checked')) {
                const parent = $(input).closest('.c-radiobtn');
                const method = parent.data('radio');

                ACC.checkoutPreValid.checkPaymentMethod(method);
            }
        });
    },

    addRadioHandler() {
        $('.c-radiobtn__input').on('change', function () {
            const parent = $(this).closest('.c-radiobtn');
            const method = parent.data('radio');

            if (ACC.utils.isHedTheme()) {
                const paypal = $('#payPalType');
                const card = $('.savedCardRadioBtn');
                const intern = $('#payinternType');

                if (paypal.is(':checked')) {
                    paypal.attr('aria-checked', true);
                    card.attr('aria-checked', false);
                    intern.attr('aria-checked', false);
                }
                if (card.is(':checked')) {
                    paypal.attr('aria-checked', false);
                    card.attr('aria-checked', true);
                    intern.attr('aria-checked', false);
                }
                if (intern.is(':checked')) {
                    paypal.attr('aria-checked', false);
                    card.attr('aria-checked', false);
                    intern.attr('aria-checked', true);
                }
            }

            ACC.checkoutPreValid.checkPaymentMethod(method);
        });
    },

    checkPaymentMethod(method) {
        switch (method) {
        case 'newCard':
            ACC.checkoutPreValid.addNewCardHandler(ACC.checkoutPreValid.state);
            ACC.checkoutPreValid.addInputTermsHandler();
            ACC.checkoutPreValid.togglePlaceBtn('newCard');
            ACC.checkoutPreValid.method.newCart = true;
            break;
        case 'savedCard':
            ACC.checkoutPreValid.destroyEvents();
            ACC.checkoutPreValid.addSavedCardHandler(ACC.checkoutPreValid.state);
            ACC.checkoutPreValid.setCvvState(ACC.checkoutPreValid.state);
            ACC.checkoutPreValid.togglePlaceBtn('savedCard');
            ACC.checkoutPreValid.method.newCart = false;
            break;
        case 'zippay':
            ACC.checkoutPreValid.addZipPayInputTermsHandler();
            ACC.checkoutPreValid.destroyEvents();
            ACC.checkoutPreValid.toggleZipPayCheckoutBtn();
            ACC.checkoutPreValid.method.newCart = false;
            break;
        case 'applePay':
            ACC.checkoutPreValid.addInputTermsHandler();
            ACC.checkoutPreValid.destroyEvents();
            ACC.checkoutPreValid.method.newCart = false;
            ACC.applePayHelpers.showApplePayBlock();
            break;
        case 'intern':
            ACC.checkoutPreValid.addInputTermsHandler();
            ACC.checkoutPreValid.destroyEvents();
            ACC.checkoutPreValid.method.newCart = false;
            ACC.applePayHelpers.hideApplePayBlock();
            break;
        case 'paypal':
        default:
            ACC.checkoutPreValid.addInputTermsHandler();
            ACC.checkoutPreValid.destroyEvents();
            ACC.checkoutPreValid.method.newCart = false;
            ACC.applePayHelpers.hideApplePayBlock();
        }
    },

    areFormFieldsSet() {
        return ACC.secureacceptance.billingInfoFieldsSetCheck() && ACC.secureacceptance.paymentInfoFieldsSetCheck();
    },

    areZipPayFormFieldsSet() {
        return ACC.zippay.billingInfoFieldsSetCheck();
    },

    addNewCardHandler(state) {
        $('#card_accountNumber').on('keyup.validate', function () {
            const isValidCard = ACC.checkoutPreValid.validateInput($(this));
            // eslint-disable-next-line no-param-reassign
            state.newCard.cardNumber = isValidCard;
            ACC.checkoutPreValid.togglePlaceBtn('newCard');
        });
        $('#ExpiryMonth').on('change.validate', function () {
            const isValidSelect = ACC.checkoutPreValid.validateSelectValue($(this));
            // eslint-disable-next-line no-param-reassign
            state.newCard.expireMonth = isValidSelect;
            ACC.checkoutPreValid.togglePlaceBtn('newCard');
        });
        $('#ExpiryYear').on('change.validate', function () {
            const isValidSelect = ACC.checkoutPreValid.validateSelectValue($(this));
            // eslint-disable-next-line no-param-reassign
            state.newCard.expireYear = isValidSelect;
            ACC.checkoutPreValid.togglePlaceBtn('newCard');
        });
        $('#card_cvNumber').on('keyup.validate', function () {
            const isValidCvv = ACC.checkoutPreValid.validateInput($(this));
            // eslint-disable-next-line no-param-reassign
            state.newCard.cvv = isValidCvv;
            ACC.checkoutPreValid.togglePlaceBtn('newCard');
        });
    },

    addInputTermsHandler() {
        $('#Terms1').on('change.validate', () => {
            ACC.checkoutPreValid.state.terms = ACC.checkoutPreValid.termsAndConditionsChecked();

            if (ACC.checkoutPreValid.method.newCart === true) {
                ACC.checkoutPreValid.togglePlaceBtn('newCard');
            }
        });
    },

    addZipPayInputTermsHandler() {
        $('#zipPayTerms').on('change.validate', () => {
            const isChecked = ACC.checkoutPreValid.zipPayTermsAndConditionsChecked();
            ACC.checkoutPreValid.state.zipPayTerms = isChecked;
            ACC.checkoutPreValid.toggleZipPayCheckoutBtn();
        });
    },

    addSavedCardHandler(state) {
        $("input[id^='savedCardCvvNumber']").on('keyup.validate', function () {
            const isValidCvv = ACC.checkoutPreValid.validateInput($(this));
            // eslint-disable-next-line no-param-reassign
            state.savedCard.cvv = isValidCvv;
            ACC.checkoutPreValid.togglePlaceBtn('savedCard');
        });

        $('#Terms1').on('change.validate', () => {
            const isChecked = ACC.checkoutPreValid.termsAndConditionsChecked();
            ACC.checkoutPreValid.state.terms = isChecked;
            ACC.checkoutPreValid.togglePlaceBtn('savedCard');
        });
    },

    destroyEvents() {
        $('.creditcard-paypal-wrapper').find('.input').off('.validate');
        $('#placeOrder').removeAttr('disabled');
    },

    setCvvState(state) {
        const $input = $('.c-saved-card.selected').next().find('.input');
        const isValidCvv = ACC.checkoutPreValid.validateInput($input);
        // eslint-disable-next-line no-param-reassign
        state.savedCard.cvv = isValidCvv;
    },

    togglePlaceBtn(card) {
        let isValid = true;
        $('#placeOrder').removeClass('processing');

        // Check inputs for desired card
        $.each(ACC.checkoutPreValid.state[card], (key, value) => {
            if (value === false) {
                isValid = false;
            }
        });

        // Check Terms & cond
        if (!ACC.checkoutPreValid.state.terms) {
            isValid = false;
        }

        // Check Tax recalculation
        if (!ACC.checkoutPreValid.state.hasCalculatedTaxes) {
            isValid = false;
        }

        // Enable/disable Place order button depend on validation result
        if (isValid && (ACC.checkoutPreValid.areFormFieldsSet() || ACC.secureacceptance.isCardSaved())) {
            return ACC.buttonhelper.enable('.place-order-form #placeOrder');
        }
        return ACC.buttonhelper.disable('.place-order-form #placeOrder', 'Place order');
    },

    toggleZipPayCheckoutBtn() {
        let isValid = true;

        if (!ACC.checkoutPreValid.state.zipPayTerms) {
            isValid = false;
        }

        if (isValid && ACC.checkoutPreValid.areZipPayFormFieldsSet()) {
            return ACC.buttonhelper.enable('.zippay-checkout-form #zipPayCheckout');
        }
        return ACC.buttonhelper.disable('.zippay-checkout-form #zipPayCheckout', 'Continue to ZipPay');
    },

    getCardState() {
        return (ACC.checkoutPreValid.method.newCart) ? 'newCard' : 'savedCard';
    },

    validateInput($input) {
        return !!$input.val()?.length;
    },

    validateSelectValue($select) {
        return !!$select.find('option:selected').val();
    },

    termsAndConditionsChecked() {
        return $('#Terms1').is(':checked');
    },

    zipPayTermsAndConditionsChecked() {
        return $('#zipPayTerms').is(':checked');
    },
};
